module.exports = __webpack_public_path__ + "static/ecanta-case-56a8d6e8e3918ce32639ff5d657dbbb5.webp";